var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"onboarding-pagination"},[_c('li',{class:{ active: _vm.currentSlide === 1 }}),_c('li',{class:{ active: _vm.currentSlide === 2 }}),_c('li',{class:{ active: _vm.currentSlide === 3 }})])}
var staticRenderFns = []

export { render, staticRenderFns }